module.exports = __webpack_public_path__ + "static/media/user.78459cc2.svg";